import React from "react";
import { Typography, Space, Progress, Slider } from "antd";
import { DollarOutlined, SafetyOutlined } from "@ant-design/icons";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

const DetailedValuationCard = () => {
  const lowEstimate = 3160000;
  const highEstimate = 5540000;
  const valPro = 4000000;
  const confidenceScore = 90;

  return (
    <CustomCard
      title={
        <Space>
          <DollarOutlined />
          <span>Detailed Valuation</span>
        </Space>
      }
      className="card-height"
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div>
          <Title level={4}>Automated Valuation Model (AVM) Range</Title>
          <Slider
            range
            min={lowEstimate}
            max={highEstimate}
            defaultValue={[lowEstimate, highEstimate]}
            tipFormatter={(value) => `$${(value / 1000000).toFixed(2)}M`}
            disabled
          />
          <Space
            direction="horizontal"
            size="large"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <Text>Low: ${(lowEstimate / 1000000).toFixed(2)}M</Text>
            <Text strong>${(valPro / 1000000).toFixed(2)}M</Text>
            <Text>High: ${(highEstimate / 1000000).toFixed(2)}M</Text>
          </Space>
        </div>
        <div>
          <Title level={4}>
            <Space>
              <SafetyOutlined />
              <span>Confidence Score</span>
            </Space>
          </Title>
          <Progress
            percent={confidenceScore}
            status="active"
            strokeColor={{
              "0%": "#87d068",
              "100%": "#108ee9",
            }}
          />
          <Text>
            The confidence score of {confidenceScore} out of 100 indicates
            highly reliable valuation data.
          </Text>
        </div>
        <Text type="secondary">
          Note: The Automated Valuation Model (AVM) uses advanced algorithms and
          local market data to estimate the property's value. The wide range
          reflects the unique characteristics of luxury properties in Malibu.
        </Text>
      </Space>
    </CustomCard>
  );
};

export default DetailedValuationCard;
